module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero_768.8504eaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/drive/fullscreen-image_hero_768.png
// module id = VMvy
// module chunks = 0